import { Link } from "react-router-dom";
import { useHistory } from "react-router";
//Components
import HeaderCrypto from "../../Layouts/marketLayout/HeaderCrypto";
import AliceCarousel from "react-alice-carousel";
//Styles and Icons
import styles from "./Home.module.scss";
import WalletIcon from "../../../styles/icon/Wallet_fill.svg";
import NoteFillIcon from "../../../styles/icon/Guide_fill.svg";
import RegroupIcon from "../../../styles/icon/Regroup.svg";
import PhoneIcon from "../../../styles/icon/telephone.svg";
import AskIcon from "../../../styles/icon/FAQ.svg";
import TicketIcon from "../../../styles/icon/Subtract.svg";
import SettingIcon from "../../../styles/icon/Setting_fill.svg";
import TradingIcon from "../../../styles/icon/trending_up.svg";
import UserFillIcon from "../../../styles/icon/menu/User_fill.svg";
import { CoinItems } from "./CoinItems";
import CardIcon from "../../../styles/icon/fullcard.svg";
import plusIcon from "../../../styles/icon/plusIcon.svg";
import "react-alice-carousel/lib/alice-carousel.css";
import { showPrice } from "../../../utils/priceFunc";
//Banner for slides
import banner1 from "../../../styles/pics/banner1.jpeg";
import banner2 from "../../../styles/pics/banner2.jpeg";
import banner3 from "../../../styles/pics/banner3.jpeg";
import { useEffect, useState } from "react";
import { coinUsersBalance } from "../../../services/userServices";
import { useSelector } from "react-redux";
export default function Home() {
  const history = useHistory();
  const userId = useSelector((state) => state.userId);
  const [userRialBalance, setUserRialBalance] = useState("");
  useEffect(() => {
    let mounted = true;
    if (mounted) {
      (async () => {
        let person = await localStorage.getItem("token");
        if (person) {
          const { data } = await coinUsersBalance("IRT");
          setUserRialBalance(data.asset);
        }
      })();
    }
    return () => (mounted = false);
  }, []);
  const items = [
    <img src={banner1} alt="" width="100%" height={180} />,
    <img src={banner2} alt="" width="100%" height={180} />,
    <img src={banner3} alt="" width="100%" height={180} />,
  ];

  return (
    <div className={`${styles.container} font_color_white`}>
      <header className={styles.header}>
        <div>
          <HeaderCrypto />
        </div>
        {userId.userHashCode && (
          <div className={styles.bg_card}>
            <div className={styles.card}>
              <img
                src={CardIcon}
                alt="BANK"
                width={33}
                height={33}
                onClick={() => history.push("/my-profile/increase-balance")}
              />

              <div
                className={styles.increase_balance_plus}
                onClick={() => history.push("/my-profile/increase-balance")}
              >
                <img src={plusIcon} alt="" width={6} height={6} />
              </div>
            </div>
            <div
              className={`changeBackgroundToGreen ${styles.user_rial_balance}`}
              onClick={() => history.push("/my-profile/increase-balance")}
            >
              {userRialBalance &&
                showPrice(
                  userRialBalance.balance - userRialBalance.locked
                )}{" "}
              <span>تومان</span>
            </div>
          </div>
        )}
        <div
          className={styles.prof}
          onClick={() => history.push("/my-profile")}
        >
          <img src={UserFillIcon} alt="PROFILE" width={30} height={30} />
        </div>
      </header>
      <div className={styles.top_menu}>
        <Link to="/my-wallet">
          <div className={styles.top_menu_item} style={{ marginTop: "-3px" }}>
            <div className={`convertPicToGreen ${styles.item_icon}`}>
              <img src={WalletIcon} alt="wallet" width="23px" height="23px" />
            </div>
            <div className={`${styles.item_title} font_color_white`}>
              کیف پول
            </div>
          </div>
        </Link>
        <Link to="/app-guid">
          <div className={styles.top_menu_item}>
            <div
              className={`convertPicToGreen ${styles.item_icon}`}
              style={{ paddingLeft: "11px" }}
            >
              <img src={NoteFillIcon} alt="Note" width="25px" height="25px" />
            </div>
            <div className={`${styles.item_title} font_color_white`}>
              راهنما
            </div>
          </div>
        </Link>
        <div className={styles.top_menu_item}>
          <div className={`convertPicToGreen ${styles.item_icon}`}>
            <img src={PhoneIcon} alt="Support" width="22px" height="22px" />
          </div>
          <div className={`${styles.item_title} font_color_white`}>
            پشتیبانی
          </div>
        </div>
        <Link to="/convert">
          <div className={styles.top_menu_item}>
            <div className={`convertPicToGreen ${styles.item_icon}`}>
              <img src={RegroupIcon} alt="Regroup" width="23px" height="23px" />
            </div>
            <div className={`${styles.item_title} font_color_white`}>تبدیل</div>
          </div>
        </Link>
        <Link to="/my-tickets">
          <div className={styles.top_menu_item} style={{ marginTop: "6px" }}>
            <div
              className={`convertPicToGreen ${styles.item_icon}`}
              style={{ paddingLeft: "2px" }}
            >
              <img src={TicketIcon} alt="Ticket" width="22px" height="22px" />
            </div>
            <div className={`${styles.item_title} font_color_white`}>تیکت</div>
          </div>
        </Link>
        <Link to="/faq">
          <div className={styles.top_menu_item} style={{ marginTop: "2px" }}>
            <div className={`convertPicToGreen ${styles.item_icon}`}>
              <img src={AskIcon} alt="Ask" width="23px" height="23px" />
            </div>
            <div className={`${styles.item_title} font_color_white`}>
              سوالات متداول
            </div>
          </div>
        </Link>

        <Link to="trades-list">
          <div className={styles.top_menu_item}>
            <div
              className={`convertPicToGreen ${styles.item_icon}`}
              style={{ paddingTop: "0" }}
            >
              <img src={TradingIcon} alt="Trade" width="25px" height="25px" />
            </div>
            <div className={`${styles.item_title} font_color_white`}>
              قیمت لحظه ای
            </div>
          </div>
        </Link>
        <Link to="/setting">
          <div className={styles.top_menu_item}>
            <div className={`convertPicToGreen ${styles.item_icon}`}>
              <img src={SettingIcon} alt="Setting" width="25px" height="25px" />
            </div>
            <div className={`${styles.item_title} font_color_white`}>
              تنطیمات
            </div>
          </div>
        </Link>
      </div>

      <div className={styles.swipe_container}>
        <AliceCarousel
          mouseTracking
          items={items}
          autoPlay={true}
          autoPlayInterval={4500}
          itemsInSlider={1}
          infinite
          responsive={{
            0: {
              items: 1,
            },
            490: {
              items: 2 / 1,
            },
          }}
        />
      </div>
      <CoinItems />
    </div>
  );
}
